/**
 * A client-generated key that makes a write idempotent.
 *
 * Payments are the reason this exists. A double-tapped Pay button, or a bulk
 * payout retried after a connection dropped mid-request, would otherwise
 * disburse twice — the server upserts on this instead. Punch sessions in the
 * mobile app carry the same protection.
 *
 * `crypto.randomUUID` where the browser has it; otherwise a timestamp and two
 * random segments, which is more than enough uniqueness for a value that only
 * has to be unique within one builder's payments.
 */
export function newIdempotencyKey(prefix = 'p') {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return `${prefix}-${crypto.randomUUID()}`;
  }
  return `${prefix}-${Date.now().toString(36)}-${Math.random()
    .toString(36)
    .slice(2, 10)}-${Math.random().toString(36).slice(2, 10)}`;
}
